import { Precio } from '@eg/compartido'
import { Link } from 'react-router-dom'
import { es } from '../../content/es'
import { supabase } from '../../lib/supabase'
import { precioDesde, type ProductoCatalogo } from './datos'

const c = es.catalogo

export function urlImagen(ruta: string | null): string | null {
  if (!ruta || !supabase) return null
  if (ruta.startsWith('https://')) return ruta // fotos de la demostración
  return supabase.storage.from('productos').getPublicUrl(ruta).data.publicUrl
}

type Props = {
  producto: ProductoCatalogo
  listaPublicaId: string | null
  listaSocioId: string | null
  /** Nivel del nombre: h3 bajo un h2 de sección (portada), h2 bajo el h1 de la página. */
  nivel?: 'h2' | 'h3'
}

/** Tarjeta de producto: imagen, categoría, nombre y el precio más bajo (de socio si lo hay). */
export function TarjetaProducto({ producto, listaPublicaId, listaSocioId, nivel = 'h3' }: Props) {
  const Titulo = nivel
  const imagen = urlImagen(producto.imagen_ruta)
  const desde = precioDesde(producto, listaPublicaId, listaSocioId)
  return (
    <article className="producto">
      <Link className="producto__enlace" to={`/producto/${producto.slug}`}>
        <div className="producto__imagen">
          {imagen ? <img src={imagen} alt={producto.nombre_comercial} width={480} height={480} loading="lazy" /> : <span>{c.sinImagen}</span>}
        </div>
        <div className="producto__cuerpo">
          {producto.categoria && <p className="producto__categoria">{producto.categoria.nombre}</p>}
          <Titulo className="producto__nombre">{producto.nombre_comercial}</Titulo>
          {producto.marca && <p className="producto__marca">{producto.marca}</p>}
          <p className="producto__precio">
            {desde ? (
              <>
                <span className="producto__desde">{desde.esSocio ? c.precioSocio : c.desde}</span>
                <Precio importe={desde.importe} usd={desde.usd} />
              </>
            ) : (
              <span className="producto__desde">{c.sinPrecio}</span>
            )}
          </p>
        </div>
      </Link>
    </article>
  )
}
